import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.94894 21.687c1.15298 0 2.30496-.438 3.18196-1.315l8.1309-8.1319c2.34-2.33995 2.34-6.1459 0-8.48587-2.339-2.33897-6.1439-2.33897-8.4839 0L3 11.5331l1.41398 1.414 7.77792-7.77889c1.559-1.55798 4.0979-1.55798 5.6559 0 1.56 1.55998 1.56 4.09795 0 5.65789L9.71691 18.958c-.97398.973-2.55996.974-3.53595 0-.97399-.975-.97399-2.5619 0-3.5369l6.71794-6.71594c.376-.37799 1.033-.37799 1.414 0 .19.189.293.439.293.707 0 .26599-.104.51699-.293.70694l-6.36396 6.364 1.41398 1.4139 6.36388-6.3639c.567-.567.879-1.321.879-2.12094 0-.80199-.312-1.55598-.879-2.12198-1.1319-1.13198-3.1099-1.13098-4.2429.001L4.76698 14.0071c-1.75498 1.755-1.75498 4.6099 0 6.3649.87699.877 2.03097 1.315 3.18196 1.315z",
    fill: "currentColor"
  }));
});